import React from 'react';
import PropTypes from 'prop-types';

// Mapeamento de estilos baseado no tipo de botão
const buttonStyles = {
  limpar:
    'bg-gray-200 text-gray-700 hover:bg-gray-300 px-6 py-2.5 rounded-lg shadow-md text-base font-medium transition transform duration-300 ease-in-out focus:outline-none focus:ring-4 focus:ring-gray-200 focus:ring-opacity-50 active:scale-95',
  editar:
    'bg-gradient-to-r rounded-3x1 from-primary to-primary-hover text-white hover:from-primary-hover hover:to-secondary',
  detalhes:
    'bg-gradient-to-r rounded-3x1 from-primary to-primary-hover text-white hover:from-primary-hover hover:to-secondary',
  remover:
    'bg-gradient-to-r rounded-3x1 from-error to-red-600 text-white hover:from-red-600 hover:to-red-700',
  cancelar:
    'bg-gradient-to-r rounded-3x1 from-gray-200 to-gray-400 text-black hover:from-gray-300 hover:to-gray-500',
  fechar:
    'bg-gradient-to-r rounded-3x1 from-gray-500 to-gray-600 text-white hover:from-gray-600 hover:to-gray-700',
  salvar:
    'bg-gradient-to-r rounded-3x1 from-success to-green-600 text-white hover:from-green-500 hover:to-green-700',
  pesquisar:
    'bg-gradient-to-r rounded-3x1 from-info to-blue-500 text-white hover:from-blue-500 hover:to-blue-600',
  entrar:
    'bg-gradient-to-r rounded-3x1 from-primary to-primary-hover text-white hover:from-primary-hover hover:to-secondary',
  cadastrar:
    'bg-gradient-to-r rounded-3x1 from-success to-green-600 text-white hover:from-green-600 hover:to-green-700',
  criarConta:
    'bg-gradient-to-r rounded-3x1 from-warning to-yellow-500 text-black hover:from-yellow-500 hover:to-yellow-600',
  atendimento:
    'bg-gradient-to-r rounded-3x1 from-purple-400 to-purple-500 text-white hover:from-purple-500 hover:to-purple-600',
  voltar:
    'bg-gradient-to-r rounded-3x1 from-gray-200 to-gray-400 text-black hover:from-gray-300 hover:to-gray-500',
  confirmar:
    'bg-gradient-to-r rounded-3x1 from-success to-green-600 text-white hover:from-green-600 hover:to-green-700',
  enviar:
    'bg-gradient-to-r rounded-3x1 from-primary to-primary-hover text-white hover:from-primary-hover hover:to-secondary',
  autopreencher:
    'bg-gradient-to-r rounded-3x1 from-blue-500 to-blue-600 text-white hover:from-blue-600 hover:to-blue-700',
  iconFechar:
    'bg-gradient-to-r rounded-lg from-error to-red-600 text-white hover:from-red-600 hover:to-red-700 w-10 h-10 flex items-center justify-center',
  expandir:
    'bg-gradient-to-r rounded-3x1 from-gray-500 to-gray-700 text-white hover:from-gray-600 hover:to-gray-800',
  default:
    'bg-gradient-to-r rounded-3x1 from-gray-100 to-gray-200 text-black hover:from-gray-200 hover:to-gray-300',
};

// Componente genérico de botão
const Button = ({
  type = 'default', // Tipo de botão, 'default' como valor padrão
  label, // Texto ou elemento JSX exibido no botão
  onClick, // Função a ser chamada no clique
  disabled = false, // Estado desabilitado
  className = '', // Classe adicional opcional para customização extra
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${
        buttonStyles[type]
      } px-6 py-2.5 rounded-lg shadow-md text-base font-medium transition transform duration-300 ease-in-out focus:outline-none focus:ring-4 focus:ring-opacity-50 active:scale-95 ${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      } ${className}`}
    >
      {label}
    </button>
  );
};

// Definindo os tipos das props com prop-types
Button.propTypes = {
  type: PropTypes.oneOf([
    'limpar',
    'editar',
    'remover',
    'cancelar',
    'fechar',
    'salvar',
    'pesquisar',
    'entrar',
    'cadastrar',
    'criarConta',
    'atendimento',
    'voltar',
    'confirmar',
    'enviar',
    'autopreencher',
    'iconFechar',
    'expandir', // Novo tipo adicionado
    'default',
  ]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired, // Garantindo que label é obrigatório e pode ser string ou JSX
  onClick: PropTypes.func.isRequired, // Tornar obrigatório para garantir o funcionamento
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default Button;
